<header>
  <div class="img"></div>
  <h3>{{'Game not found' | translate}}</h3>
</header>
<p>{{'We\'re sorry' | translate}}</p>
<p>{{'But it was not possible to find the requested page' | translate}}</p>
<button onclick="history.back(2)">{{'Go back' | translate}}</button>
